<script>
  import { systemTooltip } from "../../editor/utility.js";
  let id = "system-tooltip";
</script>

{#if $systemTooltip?.content !== undefined}
  <div
    {id}
    class="hoverHelper"
    style={`z-index: 9999;` +
      ($systemTooltip.x < window.innerWidth * 0.75
        ? `left: ${$systemTooltip.x}px;`
        : `right: ${window.innerWidth - $systemTooltip.x + 10}px;`) +
      ($systemTooltip.y < window.innerHeight * 0.75
        ? `top: ${$systemTooltip.y}px;`
        : `bottom: ${window.innerHeight - $systemTooltip.y + 10}px;`)}
  >
    {$systemTooltip.content}
  </div>
{/if}

<style>
  .hoverHelper {
    position: fixed;
    padding: 0.3rem 0.5rem;
    max-width: 20rem;
    font-size: 0.8rem;
    color: #454545;
    background: #f3f3f3;
    border: 1px solid #ddd;
    border-radius: var(--default-radius);
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
  }
</style>
